import * as stylex from "@stylexjs/stylex";
import useLocale from "hooks/useLocale";
import { defineMessage, useIntl } from "react-intl";
import { useRTL } from "../hooks";
const logoSrc = {
    UNESCO: {
        positive: {
            LTR: new URL("../assets/bg_brandmark-positive_unesco-UNESCO.svg", import.meta.url).href,
            RTL: new URL("../assets/bg_brandmark-positive_unesco-rtl-UNESCO.svg", import.meta.url).href
        },
        negative: {
            LTR: new URL("../assets/bg_brandmark-negative_unesco-UNESCO.svg", import.meta.url).href,
            RTL: new URL("../assets/bg_brandmark-negative_unesco-rtl-UNESCO.svg", import.meta.url).href
        }
    },
    GEM: {
        positive: {
            LTR: new URL("../assets/bg_brandmark-positive_unesco-GEM.svg", import.meta.url).href,
            RTL: new URL("../assets/bg_brandmark-positive_unesco-rtl-GEM.svg", import.meta.url).href
        },
        negative: {
            LTR: new URL("../assets/bg_brandmark-negative_unesco-GEM.svg", import.meta.url).href,
            RTL: new URL("../assets/bg_brandmark-negative_unesco-rtl-GEM.svg", import.meta.url).href
        }
    },
    SCOPE: {
        positive: {
            LTR: new URL("../assets/bg_brandmark-positive_unesco-SCOPE.svg", import.meta.url).href,
            RTL: new URL("../assets/bg_brandmark-positive_unesco-rtl-SCOPE.svg", import.meta.url).href
        },
        negative: {
            LTR: new URL("../assets/bg_brandmark-negative_unesco-SCOPE.svg", import.meta.url).href,
            RTL: new URL("../assets/bg_brandmark-negative_unesco-rtl-SCOPE.svg", import.meta.url).href
        }
    }
};
const logoMetadata = {
    UNESCO: {
        getHref: (_)=>"https://www.unesco.org",
        alt: defineMessage({
            id: "UNESCO logo",
            defaultMessage: "UNESCO logo"
        })
    },
    GEM: {
        getHref: (d)=>{
            // GEM Report page is not available in German
            return `https://www.unesco.org/gem-report/${d === "de" ? "en" : d}`;
        },
        alt: defineMessage({
            id: "GEM Report logo",
            defaultMessage: "GEM Report logo"
        })
    },
    SCOPE: {
        getHref: (d)=>`https://www.education-progress.org/${d}`,
        alt: defineMessage({
            id: "Education Progress logo",
            defaultMessage: "Education Progress logo"
        })
    }
};
const styles = {
    large: {
        kZKoxP: "xnnlda6",
        $$css: true
    },
    small: {
        kZKoxP: "xsdox4t",
        $$css: true
    },
    extrasmall: {
        kZKoxP: "x1vqgdyp",
        $$css: true
    },
    hover: {
        kKhh5M: "x1mdnquu",
        $$css: true
    },
    row: {
        k1xSpc: "x78zum5",
        $$css: true
    },
    rowNormal: {
        kXwgrk: "x1q0g3np",
        $$css: true
    },
    rowReverse: {
        kXwgrk: "x15zctf7",
        $$css: true
    }
};
function Logo({ size }) {
    const intl = useIntl();
    return <img {...stylex.props(styles[size])} src={new URL("../assets/logo.svg", import.meta.url).href} alt={intl.formatMessage(defineMessage(logoMetadata.SCOPE.alt))}/>;
}
export function LogoIO(props) {
    return <Logo {...props}/>;
}
function MultiLogo({ size, variant = "negative" }) {
    const locale = useLocale();
    const intl = useIntl();
    const isRTL = useRTL();
    const logos = isRTL ? [
        "SCOPE",
        "GEM"
    ] : [
        "GEM",
        "SCOPE"
    ];
    return <div {...{
        0: {
            className: "x78zum5 x1q0g3np"
        },
        1: {
            className: "x78zum5 x15zctf7"
        }
    }[!!isRTL << 0]}>
      {logos.map((logo)=>{
        const src = logoSrc[logo][variant][isRTL ? "RTL" : "LTR"];
        const { getHref, alt } = logoMetadata[logo];
        const href = getHref(locale);
        return <a key={src} href={href} target="_blank" rel="noreferrer">
            <img src={src} {...stylex.props(styles[size], styles.hover)} alt={intl.formatMessage(alt)}/>
          </a>;
    })}
    </div>;
}
export function MultiLogoIO(props) {
    return <MultiLogo {...props}/>;
}
